import { defineMessages } from 'react-intl';

export default defineMessages({
  aboutLink: {
    id: 'footerLarge.aboutLink',
    defaultMessage: 'About',
  },
  claimsLink: {
    id: 'footerLarge.claimsLink',
    defaultMessage: 'Claims',
  },
  termsLink: {
    id: 'footerLarge.termsLink',
    defaultMessage: 'Terms & Conditions',
  },
  privacyLink: {
    id: 'footerLarge.privacyLink',
    defaultMessage: 'Privacy Policy',
  },
  helpLink: {
    id: 'footerLarge.helpLink',
    defaultMessage: 'Help',
  },
  loginLink: {
    id: 'footerLarge.loginLink',
    defaultMessage: 'Login',
  },
  logoutLink: {
    id: 'footerLarge.logoutLink',
    defaultMessage: 'Logout',
  },
});
